// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.toolbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.toolbar-container .title-container {
  display: flex;
  align-items: center;
}
.toolbar-container .title-container .logo-text {
  color: #0A4064;
  font-size: 2.5rem;
  font-weight: 600;
  margin-left: 15px;
  margin-top: -15px;
  margin-bottom: -10px;
}

@media only screen and (max-width: 1182px) {
  .logo-container {
    transform: scale(0.7);
  }
  .text-container {
    margin-top: 3px;
    margin-left: -18px !important;
  }
  .logo-text {
    font-size: 1.7rem !important;
  }
}
@media only screen and (max-width: 893px) {
  .logo-container {
    transform: scale(0.6);
  }
  .text-container {
    margin-top: 5px;
    margin-left: -18px !important;
  }
  .logo-text {
    font-size: 1.3rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Toolbar.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AASJ;AAPI;EACI,aAAA;EACA,mBAAA;AASR;AAPQ;EACI,cDCF;ECAE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AASZ;;AAFA;EACI;IACI,qBAAA;EAKN;EAFE;IACI,eAAA;IACA,6BAAA;EAIN;EADE;IACI,4BAAA;EAGN;AACF;AAAA;EACI;IACI,qBAAA;EAEN;EACE;IACI,eAAA;IACA,6BAAA;EACN;EAEE;IACI,4BAAA;EAAN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n.toolbar-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .title-container {\n        display: flex;\n        align-items: center;\n\n        .logo-text {\n            color: $dk-blue;\n            font-size: 2.5rem;\n            font-weight: 600;\n            margin-left: 15px;\n            margin-top: -15px;\n            margin-bottom: -10px;\n        }\n    }\n}\n\n// ----------------------------------------------------\n// Media queries\n@media only screen and (max-width: 1182px) {\n    .logo-container {\n        transform: scale(.7);\n    }\n\n    .text-container {\n        margin-top: 3px;\n        margin-left: -18px !important;\n    }\n\n    .logo-text {\n        font-size: 1.7rem !important;\n    }\n}\n\n@media only screen and (max-width: 893px) {\n    .logo-container {\n        transform: scale(.6);\n    }\n\n    .text-container {\n        margin-top: 5px;\n        margin-left: -18px !important;\n    }\n\n    .logo-text {\n        font-size: 1.3rem !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
